import { render, staticRenderFns } from "./TextLayer.vue?vue&type=template&id=b31570dc&"
import script from "./TextLayer.vue?vue&type=script&lang=ts&"
export * from "./TextLayer.vue?vue&type=script&lang=ts&"
import style0 from "./TextLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports